import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=009308e4&scoped=true"
import script from "./channelList.vue?vue&type=script&lang=js"
export * from "./channelList.vue?vue&type=script&lang=js"
import style0 from "./channelList.vue?vue&type=style&index=0&id=009308e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009308e4",
  null
  
)

export default component.exports